import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetPreviousInvoices as GetPreviousInvoicesQuery,
    GetPreviousInvoices_previousInvoices as PreviousInvoice,
} from 'nutshell-graphql-types';

import GET_PREVIOUS_INVOICES from '../queries/get-previous-invoices.graphql';

export const useGetPreviousInvoices = (): {
    isLoading: boolean;
    previousInvoices: PreviousInvoice[] | null | undefined;
    errorMessage: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {
        loading: isLoading,
        data,
        error,
        refetch,
    } = useQuery<GetPreviousInvoicesQuery, Record<any, any>>(GET_PREVIOUS_INVOICES);

    const previousInvoices = data ? data.previousInvoices : null;

    return {
        isLoading,
        previousInvoices,
        refetch,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
    };
};
